<template>
    <div>
        <v-row justify="center" align="center">
            <v-dialog transition="dialog-bottom-transition" v-model="dialog" persistent max-width="400">
                <v-card>
                    <v-toolbar flat dense>
                        <v-toolbar-title>
                            {{ `${$t("common.to_open")} ${$route.params.folder_name}` }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text :style="`background-color: ${background_color}`">
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="password"
                                    :label="`${$t('common.password')}`"
                                    solo
                                    rounded
                                    autofocus
                                    :color="input_color"
                                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                    @click:append="showPassword = !showPassword"
                                    :type="!showPassword ? 'password' : 'text'"
                                    @keyup.enter="open"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="teal" outlined depressed @click="$router.go(-1)">
                            {{ $t("common.close") }}
                            <v-icon right>mdi-close</v-icon>
                        </v-btn>
                        <v-btn color="teal" dark depressed @click="open">
                            {{ $t("common.to_open") }}
                            <v-icon right>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import axios from "axios";
import {ref} from "vue";
import useTools from "@/use/Tools";

export default {
    setup() {
        const dialog = ref(true);
        const loading = ref(false);
        const showPassword = ref(false);
        const password = ref(null);

        const {$router, $route} = useTools();

        function open() {
            loading.value = true;
            axios.put("/folders/setFolderName", null, {
                params: {
                    folderName: $route.params.folder_name,
                    password: password.value,
                },
            }).then(() => {
                $router.push({name: "notifications"});
            }).finally(() => {
                loading.value = false;
            });
        }

        return {
            dialog,
            loading,
            showPassword,
            password,
            open
        }
    }
};
</script>